import './Spinner.scss'
import { clx } from '../clx'

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  /** Accessible label. Without one the spinner is decorative (aria-hidden). */
  label?: string
  className?: string
}

export function Spinner({ size = 'md', label, className }: SpinnerProps) {
  return (
    <span
      className={clx('spinner', size !== 'md' && `spinner--is-${size}`, className)}
      // A still spinner reads as frozen: its rotation is essential (ADR 0021).
      data-motion="essential"
      {...(label ? { role: 'status', 'aria-label': label } : { 'aria-hidden': true })}
    />
  )
}
